module.exports = __webpack_public_path__ + "img/oltrepo.99e1e526.jpg";